export const color1Default: string = '#B4AEFE'
export const color2Default: string = '#F3F5FE'
